import { render, staticRenderFns } from "./VoiceBot.vue?vue&type=template&id=24272ece&"
import script from "./VoiceBot.vue?vue&type=script&lang=js&"
export * from "./VoiceBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports